<template>
  <div>
    <EditStudiesPopup @edit="handleMultiEdit" ref="study-edition" :data="studyEditionData" :dependencies="dependencies" />
    <ul class="nav nav-tabs" style="margin-left: 28px" role="tablist">
      <li class="nav-item">
        <h5 class="nav-link" :class="{active: activeTab === 'summaries',show: activeTab === 'summaries'}"
            @click="switchTabs('summaries')">
          Study summaries <span v-if="summaries && summaries.length"
                                class="badge badge-primary ml-1">{{summaries.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.fragranceTab">
        <h5 class="nav-link" :class="{active: activeTab === 'fragrances',show: activeTab === 'fragrances'}"
            @click="switchTabs('fragrances')">
          Fragrances <span v-if="fragrances && fragrances.length"
                           class="badge badge-primary ml-1">{{fragrances.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.conceptTab">
        <h5 class="nav-link" :class="{active: activeTab === 'concepts',show: activeTab === 'concepts'}"
            @click="switchTabs('concepts')">
          Concepts <span v-if="concepts && concepts.length"
                           class="badge badge-primary ml-1">{{concepts.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.screeners">
        <h5 class="nav-link" :class="{active: activeTab === 'screener',show: activeTab === 'screener'}"
            @click="switchTabs('screener')">
          Screeners <span v-if="screeners && screeners.length"
                          class="badge badge-primary ml-1">{{screeners.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.questionnaires">
        <h5 class="nav-link"
            :class="{active: activeTab === 'questionnaire',show: activeTab === 'questionnaire'}"
            @click="switchTabs('questionnaire')">
          Questionnaires <span v-if="questionnaires && questionnaires.length" class="badge badge-primary ml-1">{{questionnaires.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.protocols">
        <h5 class="nav-link" :class="{active: activeTab === 'protocol',show: activeTab === 'protocol'}"
            @click="switchTabs('protocol')">
          Protocols <span v-if="protocols && protocols.length"
                          class="badge badge-primary ml-1">{{protocols.length}}</span>
        </h5>
      </li>
      <li class="nav-item" v-b-tooltip.hover.html="tooltips.results">
        <h5 class="nav-link" :class="{active: activeTab === 'RDF_report',show: activeTab === 'RDF_report'}"
            @click="switchTabs('RDF_report')">
          Results/Reports <span v-if="combinedResultsReports && combinedResultsReports.length"
                        class="badge badge-primary ml-1">{{combinedResultsReports.length}}</span>
        </h5>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane" :class="{active: activeTab === 'summaries',show: activeTab === 'summaries'}">
        <Loader :show="isReady" :fixed="false"/>
        <SummaryTable @multi-study-edit="handleEdition" :data="summaries" ref="summary-table" :isReady="isReady" :parseSearchData="parseData"></SummaryTable>
      </div>
      <div class="tab-pane" :class="{active: activeTab === 'fragrances',show: activeTab === 'fragrances'}">
        <Loader :show="isReady" :fixed="false"/>
        <FragranceTable @multi-study-edit="handleEdition" :data="fragrances" ref="fragrance-table" :isReady="isReady" :parseSearchData="parseData"></FragranceTable>
      </div>
      <div class="tab-pane" :class="{active: activeTab === 'concepts',show: activeTab === 'concepts'}">
        <Loader :show="isReady" :fixed="false"/>
        <ConceptsTable @multi-study-edit="handleEdition" :data="concepts" ref="concept-table" :isReady="isReady" :parseSearchData="parseData"></ConceptsTable>
      </div>
      <div class="tab-pane" :class="{active: activeTab === 'screener',show: activeTab === 'screener'}">
        <Loader :show="screenerReady" :fixed="false"/>
        <FileTable @multi-study-edit="handleEdition" :data="screeners" :file-type="'screener'" :isReady="isReady"
                   v-on:search="isFileTableReady.screener = false"
                   v-on:search-end="isFileTableReady.screener = true"
                   v-on:download-fail="toggleAlert('danger', 'exclamation-circle', 'There was an issue with downloading your file.')"></FileTable>
      </div>
      <div class="tab-pane"
           :class="{active: activeTab === 'questionnaire',show: activeTab === 'questionnaire'}">
        <Loader :show="questionnaireReady" :fixed="false"/>
        <FileTable @multi-study-edit="handleEdition" :data="questionnaires" :file-type="'questionnaire'" :isReady="isReady"
                   v-on:search="isFileTableReady.questionnaire = false"
                   v-on:search-end="isFileTableReady.questionnaire = true"
                   v-on:download-fail="toggleAlert('danger', 'exclamation-circle', 'There was an issue with downloading your file.')"></FileTable>
      </div>
      <div class="tab-pane"
           :class="{active: activeTab === 'protocol',show: activeTab === 'protocol'}">
        <Loader :show="protocolReady" :fixed="false"/>
        <FileTable @multi-study-edit="handleEdition" :data="protocols" :file-type="'protocol'" :isReady="isReady"
                   v-on:search="isFileTableReady.protocol = false"
                   v-on:search-end="isFileTableReady.protocol = true"
                   v-on:download-fail="toggleAlert('danger', 'exclamation-circle', 'There was an issue with downloading your file.')"></FileTable>
      </div>
      <div class="tab-pane"
           :class="{active: activeTab === 'RDF_report',show: activeTab === 'RDF_report'}">
        <Loader :show="resultReady || reportReady" :fixed="false"/>
        <FileTable @multi-study-edit="handleEdition" :data="combinedResultsReports" :file-type="'RDF_report'" :isReady="isReady"
                   v-on:search="isFileTableReady.result = false"
                   v-on:search-end="isFileTableReady.result = true"
                   v-on:download-fail="toggleAlert('danger', 'exclamation-circle', 'There was an issue with downloading your file.')"></FileTable>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryTable from './Tables/SummaryTable'
import FragranceTable from './Tables/FragranceTable'
import ConceptsTable from './Tables/ConceptsTable'
import FileTable from './Tables/FileTable'
import { mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import tooltips from '../../constants/tooltips'
import Loader from '../shared/Loader'
import EditStudiesPopup from './EditStudiesPopup'

export default {
  name: 'SearchTabs',
  components: { EditStudiesPopup, Loader, FileTable, FragranceTable, SummaryTable, ConceptsTable },
  props: {
    isReady: Boolean,
    ready: Boolean,
    parseData: Function,
    toggleAlert: Function,
    switchTabs: Function,
    activeTab: String,
    collapsed: Boolean,
    dependencies: Array
  },
  data () {
    return {
      isFileTableReady: {
        result: true,
        protocol: true,
        questionnaire: true,
        screener: true,
        report: true
      },
      tooltips,
      studyEditionData: null
    }
  },
  computed: {
    ...mapGetters({
      fragrances: studiesGetters.GET_FRAGRANCES,
      concepts: studiesGetters.GET_CONCEPTS,
      questionnaires: studiesGetters.GET_QUESTIONNAIRES,
      reports: studiesGetters.GET_REPORTS,
      protocols: studiesGetters.GET_PROTOCOLS,
      results: studiesGetters.GET_RESULTS,
      screeners: studiesGetters.GET_SCREENERS,
      summaries: studiesGetters.GET_STUDY_SUMMARIES
    }),
    resultReady () {
      return this.isReady || !this.isFileTableReady.result
    },
    protocolReady () {
      return this.isReady || !this.isFileTableReady.protocol
    },
    questionnaireReady () {
      return this.isReady || !this.isFileTableReady.questionnaire
    },
    screenerReady () {
      return this.isReady || !this.isFileTableReady.screener
    },
    reportReady () {
      return this.isReady || !this.isFileTableReady.report
    },
    combinedResultsReports () {
      if (!this.reportReady && !this.reportReady) return [...this.results, ...this.reports]
      return []
    }
  },
  methods: {
    handleEdition (data) {
      this.studyEditionData = data
      this.$refs['study-edition'].showPopup()
    },
    handleMultiEdit () {
      this.$emit('multiple-edit')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
@import url('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');

.tab-pane {
  min-height: 555px;
  overflow: unset;
}

.nav-link {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  color: #A46743 !important;

  &:hover {
    border-bottom-color: $charcoal !important;
  }

  &.active {
    position: relative;
    color: $input-label !important;

    &:hover {
      border-bottom-color: transparent !important;
    }

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      width: 80%;
      left: 10%; /*this centers it based on the above width*/
      border-bottom: 2px solid $dusty-blue;
    }
  }
}

.badge {
  border-radius: 2px;
  background-color: $blueberry !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
}

.tab-content {
  border: 1px solid $charcoal;
  border-left: 0;
  border-right: 0;
}

.open-filter-button {
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 24px;
  font-size: 35px;
  line-height: 35px;
  height: 35px;
  color: $home-card;
  cursor: pointer;
  transition: color 0.2s linear;

  &.files {
    right: 310px;
  }

  &:hover {
    color: $navbar-dropdown-text
  }
}
</style>
